<script>

    import { toast } from 'bulma-toast'
    import { modalStore, providersStore } from '../stores'
    
    import ProvidersService from '../$services/providers.service'
    
    import Select from '../$components/select.svelte'
    import Button from '../$components/button.svelte'
    import Form from '../$components/form.svelte'

    let data = {}
    let loading = false

    async function createProvider() {

        loading = true
        const resp = await ProvidersService.createProvider(data)
        loading = false

        if(!resp.success)
            return toast({message: resp.error.message, type: 'is-danger'})

        providersStore.append(resp.data)
        toast({message: 'Proveedor creado', type: 'is-success'})

        modalStore.close()
    }

</script>

<Form on:submit={createProvider} { loading } >
    <div class="columns">
        <div class="column">
            <Select bind:value={data.name} label="Proveedor" options={[
                {value: 'FedEx', text: 'FedEx'},
                {value: 'DHL', text: 'DHL'},
                {value: 'Estafeta', text: 'Estafeta'},
                {value: 'Sendex', text: 'Sendex'},
                {value: 'Paquetexpress', text: 'Paquetexpress'},
                {value: 'AMPM', text: 'AMPM'},
                {value: 'UPS', text: 'UPS'},
                {value: '99Minutos', text: '99Minutos'},
            ]} />    
        </div>
    </div>
    <div class="items-end">
        <div class="buttons">
            <Button on:click={modalStore.close} text="Cancelar" icon="ban" color="light"/>
            <Button type="submit" text="Agregar" icon="plus" color="primary" { loading } />
        </div>
    </div>
</Form>